import { AskResponse, Citation, AzureSqlServerCodeExecResult } from "../../api";
import { cloneDeep } from "lodash-es";

type ParsedAnswer = {
    citations: Citation[];
    markdownFormatText: string;
    plotly_data: AzureSqlServerCodeExecResult | null;
};

const enumerateCitations = (citations: Citation[]) => {
    const filepathMap = new Map();
    for (const citation of citations) {
        const { filepath } = citation;
        let part_i = 1;
        if (filepathMap.has(filepath)) {
            part_i = filepathMap.get(filepath) + 1;
        }
        filepathMap.set(filepath, part_i);
        citation.part_index = part_i;
    }
    return citations;
};

export function parseAnswer(answer: AskResponse, hideCitations: string): ParsedAnswer {
    let answerText = answer.answer;

    const citationLinks = answerText.match(/\[(doc\d\d?\d?)]/g);

    // Debug citation markers
    // console.log("[parseAnswer] markers found in answer text:", citationLinks);
    // console.log("[parseAnswer] citations received:", answer.citations.length, answer.citations.map(c => ({ chunk_id: c.chunk_id, title: c.title })));

    const lengthDocN = "[doc".length;

    let filteredCitations = [] as Citation[];
    let citationReindex = 0;
    if (hideCitations == "false") {
        //reference documents used in knowledgeagent search. The answer text is not marked to indicate references
        if (!citationLinks && answer.citations.length>0){
            answer.citations.forEach((citation, idx) => {
                const clonedCitation = cloneDeep(citation) as Citation;
                clonedCitation.id = (idx + 1).toString();
                clonedCitation.reindex_id = (idx + 1).toString();
                filteredCitations.push(clonedCitation);
        });
        }
        citationLinks?.forEach(link => {
            // Replacing the links/citations with number
            let citationIndex = parseInt(link.slice(lengthDocN, link.length - 1), 10);
            if (isNaN(citationIndex) || citationIndex < 1 || citationIndex > answer.citations.length) {
                // malformed or out-of-range marker: strip it so it never reaches the user
                answerText = answerText.replace(new RegExp(link.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), '');
                return;
            }
            let citation = cloneDeep(answer.citations[citationIndex - 1]) as Citation;
            if (!filteredCitations.find((c) => c.id === citationIndex.toString()) && citation) {
                // markers are used to select which citations to display but are not shown inline
                answerText = answerText.replace(new RegExp(link.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), '');
                citation.id = citationIndex.toString(); // original doc index to de-dupe
                citation.reindex_id = (++citationReindex).toString(); // reindex from 1 for display
                filteredCitations.push(citation);
            }
        });
    } else {
        citationLinks?.forEach(link => {
            // Replacing the links/citations with number
            let citationIndex = parseInt(link.slice(lengthDocN, link.length - 1), 10);
            if (isNaN(citationIndex) || citationIndex < 1 || citationIndex > answer.citations.length) {
                // malformed or out-of-range marker: strip it so it never reaches the user
                answerText = answerText.replace(new RegExp(link.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), '');
                return;
            }
            let citation = cloneDeep(answer.citations[citationIndex - 1]) as Citation;
            if (!filteredCitations.find((c) => c.id === citationIndex.toString()) && citation) {
                answerText = answerText.replace(new RegExp(link.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), ``);
            }
        });
    }
    answerText = answerText.replace(/(https?:\/\/[^\s。]+|www\.[^\s。]+)(。)/g, '$1 。');

    // strip any remaining citation-marker artifacts regardless of index
    answerText = answerText.replace(/\[doc\d{1,3}\]/g, '');
    answerText = answerText.replace(/\[\^doc\d{1,3}\^\]/g, '');
    answerText = answerText.replace(/\[\^\d{1,3}\^\]/g, '');
    answerText = answerText.replace(new RegExp('\\[\\^\\]', 'g'), '');
    answerText = answerText.replace(new RegExp('\\[\\^doc\\]', 'g'), '');
    answerText = answerText.replace(new RegExp(' \\.', 'g'), '.');
    answerText = answerText.replace(new RegExp('`', 'g'), '');
    filteredCitations = enumerateCitations(filteredCitations);
    // Debug filtered citations:
    // console.log("[parseAnswer] displaying", filteredCitations.length, "citations:", filteredCitations.map(c => ({ id: c.id, reindex_id: c.reindex_id, chunk_id: c.chunk_id })));
    return {
        citations: filteredCitations,
        markdownFormatText: answerText,
        plotly_data: answer.plotly_data
    };
}